import { render, staticRenderFns } from "./firstpdf.vue?vue&type=template&id=07c14748&scoped=true"
import script from "./firstpdf.vue?vue&type=script&lang=js"
export * from "./firstpdf.vue?vue&type=script&lang=js"
import style0 from "./firstpdf.vue?vue&type=style&index=0&id=07c14748&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c14748",
  null
  
)

export default component.exports